import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ['button']

    connect() {
        this.element.classList.remove('hidden')
    }

    save() {
        this.element.classList.add('save-page-is-saved')

        var metaDescription = document.querySelector("meta[name='description']")

        axios.post('/saved', {
            url: String(window.location),
            title: String(document.title),
            description: metaDescription ? String(metaDescription.getAttribute('content')) : ''
        })
        .catch(error => {
            console.log(error);

            this.element.classList.remove('save-page-is-saved')

            if (error.response.status == '403') {
                alert('Only the student can save a page against their record.')
            } else {
                alert('Something went wrong! Please try again.')
            }
        });
    }
}
